import styled from 'styled-components';

const hexToRgba = (hex: string, opacity: number) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const WrapperAlert = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    height: 100%;
`;

export const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
`;

export const TextInfo = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;

    color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const WrapperButton = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    margin-top: 2rem;
    gap: 1rem;
`;

export const Button = styled.button<{$type: 'now' | 'latter'}>`
    width: 148px;
    height: 40px;
    border-radius: 4px;

    background-color: ${({ theme, $type }) => $type === 'now'
    ? theme.colors.accent.primary
    : hexToRgba(theme.colors.accent.primary, 0.2)};
    color: ${({ theme, $type }) => $type === 'now'
    ? theme.colors.text.inverted
    : theme.colors.accent.primary};

    &:hover {
        background-color: ${({ theme, $type }) => $type === 'now'
    ? theme.colors.accent.primary
    : hexToRgba(theme.colors.accent.primary, 0.2)};
    }
`;
